<template>
  <div class="user-button-create" @click="create">
    ユーザーの作成
  </div>
</template>

<script>
import MixinResultHandler from '@/components/MixinResultHandler'

export default {
  mixins: [ MixinResultHandler ],
  methods: {
    create: async function () {
      const result = await this.$store.dispatch('user/createUser')
      this.showSnackAndMove(result)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-button-create {
  @include button-ol-success;
}
</style>
